import { Link } from 'gatsby';
import "../../../../src/pages/design/design-guidelines-styles.css";
import { ColorSwatch } from "../../../../src/components/ColorSwatch";
import { magma } from 'react-magma-dom';
import { LeadParagraph } from "../../../../src/components/LeadParagraph";
import * as React from 'react';
export default {
  Link,
  ColorSwatch,
  magma,
  LeadParagraph,
  React
};